import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
@font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 

  .generated-images-holder-var31 {
    /* position: absolute; */
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var31 {
    width: 100%;
    display: flex;
    position: relative;
  }

  .left-div-var31, .right-div-var31 {
    width: 50%;
    height: 630px;
    position: relative;
  }

  .break-var31 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
    &--black {
      background-color: black;
    }
  }
  .left-text-var31, .right-text-var31 {
    position: absolute;
    width: 100%;
    background-color: white;
    top: 0;
    left: 0;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    -webkit-text-shadow: 1.5px 0 0 #000;
    -moz-text-shadow: 1.5px 0 0 #000;
    -ms-text-shadow: 1.5px 0 0 #000;
    -o-text-shadow: 1.5px 0 0 #000;
    text-shadow: 1.5px 0 0 #000;
    letter-spacing: 1.2px;
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 14px 25px 16px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }

  .left-text-var31__divider {
    padding: 0 13px 0 7px;
  }

  .right-text-var31__divider {
    padding: 0 7px 0 13px;
  }

  .image-var31 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .left-actual-photo-var31 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  
  .right-actual-photo-var31 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo-var31--top,
  .right-actual-photo-var31--top {
    top: 0;
    bottom: auto;
  }
 
`;

export default VariationsStyles;
